import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const IPAD = 'https://cdn.magicpatterns.com/patterns/generated-images/3dc6f4d8-3d1f-4023-b346-79228eebc173.jpg';
const PHONE = 'https://cdn.magicpatterns.com/patterns/generated-images/00fe198f-de20-4008-825e-62a25f935ecb.jpg';
const AVATARS = ['https://randomuser.me/api/portraits/women/44.jpg', 'https://randomuser.me/api/portraits/men/32.jpg', 'https://randomuser.me/api/portraits/men/54.jpg', 'https://randomuser.me/api/portraits/men/76.jpg', 'https://randomuser.me/api/portraits/women/68.jpg'];
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-white pt-16 sm:pt-24" data-id="element-99" data-mp="sa9q98dflju0">
      <div className="mx-auto w-full max-w-4xl px-5 text-center sm:px-8" data-id="element-100" data-mp="nczr3108ptsz">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-6xl md:text-7xl" data-id="element-101" data-mp="3d1a7phvug7c8">
          Reach your goals with GPS Journal
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-102" data-mp="3o6kh1mlj0k78">
          GPS Journal is a lean Notion system that tracks your goals, habits, projects, and daily
          journal, making it easy to keep moving forward.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-9 flex flex-col items-center gap-6" data-id="element-103" data-mp="35aknw8gtbam2">
          <a href="#pricing" className="inline-flex rounded-full bg-ink px-8 py-4 text-base font-semibold text-white transition-transform hover:scale-[1.03]" data-id="element-104" data-mp="2hk8522k13tgp">
            Get GPS Journal
          </a>

          
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.3
    }} className="relative mx-auto mt-14 flex w-full max-w-5xl items-end justify-center px-5 sm:mt-20" data-id="element-105" data-mp="s44i1nkpdlhw">
        <img src={IPAD} alt="GPS Journal shown on an iPad" className="w-full max-w-3xl rounded-2xl" data-id="element-106" data-mp="degiorw30wwt" />
        <img src={PHONE} alt="GPS Journal shown on a phone" className="absolute bottom-0 right-2 w-[26%] max-w-[190px] sm:right-8 md:right-16" data-id="element-107" data-mp="1b0drfxkntnvk" />
      </motion.div>
    </section>;
}